export const servicesErrorMessages = {
  stoneFast: {
    message: "- O StoneFast (antecipação automática de recebíveis) está ativo no seu contrato."
  },
  contract: {
    message: "- Você possui um contrato ativo com a Registradora TAG."
  },
  affiliation: {
    message: '- Você não possui contrato ativo com a Stone.'
  }
}

export const unavailableServicesErrorMessages = {
  default: {
    message: '- O nosso sistema de verificação está indisponível no momento. Por favor, tente novamente mais tarde.'
  }
}
